import styled, { css } from 'styled-components'
import * as styledSystem from 'styled-system'
import { colors } from './helpers'
const { space, width, fontSize, lineHeight, maxWidth, textAlign, letterSpacing, display, color, fontWeight } = styledSystem

const Image = styled.img`
  ${space};
  ${display};
  ${width};
  ${maxWidth};
  ${textAlign};
  ${fontSize};
  ${fontWeight};
  ${lineHeight};
  ${letterSpacing};
  ${color};
`

export default Image
